import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md:max-w-[666px] my-20" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium" }, "1. Wywiad medyczny", -1)
const _hoisted_3 = { class: "mt-20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-medium mt-12" }, "2. Dane pacjenta", -1)



import PatientData from '../shared/PatientData.vue';
import ImportantInformationField from '../shared/Fields/ImportantInformationField.vue';
import ProductForm from '../shared/ProductForm.vue';
import { initialValues } from './initialValues';
import { schema } from './schema';
import DateOfLastMenstruationField from '../shared/Fields/DateOfLastMenstruationField.vue';
import LastUnprotectedSexField from '../shared/Fields/LastUnprotectedSexField.vue';
import LastVisitDoctorField from '../shared/Fields/LastVisitDoctorField.vue';
import AdditionalDiseasesField from '../shared/Fields/AdditionalDiseasesField.vue';
import ContraceptionMedicineField from '../shared/Fields/ContraceptionMedicineField.vue';


export default {
  __name: 'Tabletka',
  props: {
    checkoutlink: { type: String, required: true },
    price: {
        type: String,
        required: true,
    },
    id: {
        type: Number,
        required: true,
    },
},
  setup(__props) {

const props = __props;



return (_ctx, _cache) => {
  const _component_UploadedFileField = _resolveComponent("UploadedFileField")

  return (_openBlock(), _createBlock(ProductForm, {
    schema: _unref(schema),
    initialValues: _unref(initialValues),
    id: __props.id,
    checkoutlink: __props.checkoutlink,
    price: __props.price
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(ContraceptionMedicineField),
        _createVNode(DateOfLastMenstruationField),
        _createVNode(LastUnprotectedSexField),
        _createVNode(LastVisitDoctorField),
        _createVNode(AdditionalDiseasesField),
        _createVNode(ImportantInformationField),
        _createVNode(_component_UploadedFileField)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(PatientData)
      ])
    ]),
    _: 1
  }, 8, ["schema", "initialValues", "id", "checkoutlink", "price"]))
}
}

}